import { BehaviorSubject } from 'rxjs';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { CoreThemingService } from '@ui-core/services/core-theming.service';
import { ISideMenu } from '@types-custom/models/ui/side-menu.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ActionService } from '@shared/services/action-service/action.service';

/*
 ** Side menu
 ** Render a side menu that can be toggled and contains items.
 */
@Component({
  selector: 'side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SideMenuComponent {
  @Input() isExpanded: boolean | undefined | null;
  @Output() expandedChange: EventEmitter<any> = new EventEmitter();
  @Input() leftMenuModelIcons: ISideMenu<any>[] | undefined = undefined;
  @Input() activeIcon$: BehaviorSubject<any> | undefined;
  @Input() logoText: string | '' | undefined;
  @Input() userName: string | null | undefined;
  theme$ = this.coreThemingService.theme$;
  isDisabled = false;
  Icon = Icon;
  hourBoard = '';
  dateBoard = '';
  panelOpenState = false;
  isHidden = false;

  constructor(
    private coreThemingService: CoreThemingService,
    private actionService: ActionService
  ) {
    // setInterval(() => this.dateOnBoard(), 6000); The clock is not required in the UI so it is commented by now
  }

  dispatchEvent(dispatcher$: any, event: any): void {
    this.actionService.dispatch(event, dispatcher$);

    this.expandedChange.emit(false);
  }

  // dateOnBoard() {
  //   const date = new Date();
  //   const options: Intl.DateTimeFormatOptions = {
  //     hour: 'numeric',
  //     minute: 'numeric',
  //         timeZone: 'Europe/Madrid', // Zona horaria para España peninsular
  //   };
  //   this.hourBoard = date.toLocaleString('es-ES', options);
  //   const optionsDate: Intl.DateTimeFormatOptions = {
  //     day: 'numeric',
  //     month: 'numeric',
  //     year: 'numeric',
  //         timeZone: 'Europe/Madrid', // Zona horaria para España peninsular
  //   };
  //   this.dateBoard = date.toLocaleString('es-ES', optionsDate);
  // }

  hasActiveSubmenus(item: ISideMenu, activeIcon: any) {
    // if(item.isSubmenu) return item.tagSelected;
    return this.leftMenuModelIcons?.filter(menu => menu.isSubmenu && menu.group === item.group).some(element => element.event?.action === activeIcon || element.isHover);
  }

  toggleFooter() {
    this.isHidden = !this.isHidden;
  }

  @HostListener('click', ['$event'])
  documentClick(event: any): void {
    if (this.isExpanded) {
      this.expandedChange.emit(false);
    }
  }
}
